/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 商户管理后台接口（仅平台管理员 BOSS）</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月22日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//跨账套账套分页列表
	accountSets(params = {}) {
		return Ajax.get('/admin/accountSets', params)
	},
	//启用/禁用账套
	updateStatus(p) {
		return Ajax.put('/admin/accountSets/status', p)
	},
	//跨账套用户分页列表
	users(params = {}) {
		return Ajax.get('/admin/users', params)
	},
	//启用/禁用用户
	updateUserStatus(p) {
		return Ajax.put('/admin/users/status', p)
	},
	//重置用户密码
	resetUserPassword(p) {
		return Ajax.put('/admin/users/password', p)
	},
	//用户名下账套
	userAccountSets(userId) {
		return Ajax.get('/admin/users/accountSets', {userId})
	},
	//公告分页列表
	announcements(params = {}) {
		return Ajax.get('/admin/announcements', params)
	},
	//新增公告
	addAnnouncement(p) {
		return Ajax.post('/admin/announcements', p)
	},
	//编辑公告
	updateAnnouncement(p) {
		return Ajax.put('/admin/announcements', p)
	},
	//删除公告
	deleteAnnouncement(p) {
		return Ajax.delete('/admin/announcements?id=' + p.id)
	},
	//运营统计
	stats() {
		return Ajax.get('/admin/stats')
	},
	//账套模板列表
	templates(params = {}) {
		return Ajax.get('/admin/templates', params)
	},
	//新增账套模板
	addTemplate(p) {
		return Ajax.post('/admin/templates', p)
	},
	//编辑账套模板
	updateTemplate(p) {
		return Ajax.put('/admin/templates', p)
	},
	//删除账套模板
	deleteTemplate(p) {
		return Ajax.delete('/admin/templates?id=' + p.id)
	},
	//管理账号列表
	adminAccounts(params = {}) {
		return Ajax.get('/admin/admin-accounts', params)
	},
	//添加管理账号
	addAdminAccount(p) {
		return Ajax.post('/admin/admin-accounts', p)
	},
	//更新管理账号（重置密码等）
	updateAdminAccount(p) {
		return Ajax.put('/admin/admin-accounts', p)
	},
	//移除管理账号
	deleteAdminAccount(p) {
		return Ajax.delete('/admin/admin-accounts?id=' + p.id)
	},
	//读取站点设置
	getSiteSettings() {
		return Ajax.get('/admin/site-settings')
	},
	//保存站点设置
	saveSiteSettings(p) {
		return Ajax.put('/admin/site-settings', p)
	},
	//版本列表
	versions(params = {}) {
		return Ajax.get('/admin/versions', params)
	},
	//新增版本
	addVersion(p) {
		return Ajax.post('/admin/versions', p)
	},
	//编辑版本
	updateVersion(p) {
		return Ajax.put('/admin/versions', p)
	},
	//删除版本
	deleteVersion(p) {
		return Ajax.delete('/admin/versions?id=' + p.id)
	},
	//续订代码列表
	renewalCodes(params = {}) {
		return Ajax.get('/admin/renewal-codes', params)
	},
	//批量生成续订代码
	generateRenewalCodes(p) {
		return Ajax.post('/admin/renewal-codes/generate', p)
	},
	//作废续订代码
	deleteRenewalCode(p) {
		return Ajax.delete('/admin/renewal-codes?id=' + p.id)
	},
	//角色权限列表
	permissions() {
		return Ajax.get('/admin/permissions')
	},
	//保存角色权限
	savePermissions(p) {
		return Ajax.put('/admin/permissions', p)
	},
	//操作日志列表
	logs(params = {}) {
		return Ajax.get('/admin/logs', params)
	},
	//指定账套凭证分页（只读）
	accountSetVouchers(params = {}) {
		return Ajax.get('/admin/accountSets/vouchers', params)
	},
	//指定账套续费流水
	accountSetRenewalRecords(params = {}) {
		return Ajax.get('/admin/accountSets/renewalRecords', params)
	},
	//手动赠送账套时长
	extendAccountSets(params = {}) {
		return Ajax.post('/admin/accountSets/extend', params)
	},
	//支付订单分页列表
	paymentOrders(params = {}) {
		return Ajax.get('/admin/payment-orders', params)
	},
	//手动确认收款（开通会员）
	confirmPaymentOrder(p) {
		return Ajax.put('/admin/payment-orders/confirm', p)
	},
	//关闭待支付订单
	closePaymentOrder(p) {
		return Ajax.put('/admin/payment-orders/close', p)
	},
	//用户列表全量导出地址（浏览器直接下载）
	usersExportUrl(params = {}) {
		let query = Object.keys(params)
			.filter(key => params[key] !== undefined && params[key] !== '' && params[key] !== null)
			.map(key => key + '=' + encodeURIComponent(params[key]))
			.join('&');
		return Ajax.PREFIX + '/admin/users/export' + (query ? '?' + query : '');
	},
	//续订代码全量导出地址（浏览器直接下载）
	renewalExportUrl(params = {}) {
		let query = Object.keys(params)
			.filter(key => params[key] !== undefined && params[key] !== '')
			.map(key => key + '=' + encodeURIComponent(params[key]))
			.join('&');
		return Ajax.PREFIX + '/admin/renewal-codes/export' + (query ? '?' + query : '');
	},
	//操作日志导出地址（浏览器直接下载，与列表同筛选条件）
	logsExportUrl(params = {}) {
		let query = Object.keys(params)
			.filter(key => params[key] !== undefined && params[key] !== '')
			.map(key => key + '=' + encodeURIComponent(params[key]))
			.join('&');
		return Ajax.PREFIX + '/admin/logs/export' + (query ? '?' + query : '');
	},
	//清理历史操作日志
	clearLogs(params = {}) {
		let days = params.days === undefined || params.days === null ? '' : params.days;
		return Ajax.delete('/admin/logs/clear' + (days === '' ? '' : '?days=' + encodeURIComponent(days)));
	},
	//登录日志分页列表
	loginLogs(params = {}) {
		return Ajax.get('/admin/login-logs', params)
	}
};
